import { gql } from "@apollo/client";

export const GET_ALL_USUARIOS_RESPONSABLES_COMPLETO = gql`
    query allUsuariosResponsables($idAreaReclamo: Int!) {
        allUsuariosResponsables(idAreaReclamo: $idAreaReclamo){
            idUsuario
            usuario
            nombre
            apellido
            email
        }
}`;

export const adaptUsuariosResponsablesCompletoArray = (usuarios, onDelete) =>
structuredClone(usuarios?.allUsuariosResponsables || usuarios?.allUsuariosResponsablesSinArea)?.
map((usuario) => ({
  id: usuario?.idUsuario,
  usuario: usuario?.usuario,
  nombre: usuario?.nombre,
  apellido: usuario?.apellido,
  email: usuario?.email,
  onDelete: onDelete ? onDelete : null
}));